import { combineReducers, configureStore } from "@reduxjs/toolkit";
import studentAttSlice from "./Slice/studentAttSlice";
import batchSlice from "./Slice/batchSlice";
import departmentSlice from "./Slice/departmentSlice";
import userSlice from "./Slice/userSlice";
import examSlice from "./Slice/examSlice";
import storage from "redux-persist/lib/storage"; // localStorage
import { persistStore, persistReducer, createMigrate } from "redux-persist";
import {encryptTransform} from "redux-persist-transform-encrypt";
import compressTransform from "redux-persist-transform-compress";


// ------------------ Migrations ------------------
const migrations = {
  4: () => undefined, 
  5: () => undefined, 
};

// ------------------ Encrypt Config ------------------
const encryptor = encryptTransform({
  secretKey: process.env.REACT_APP_PERSIST_KEY || "default-secret-key",
  onError: (error:any) => {
    console.error("Persist Encryption Error:", error);
  },
});
const transforms = [compressTransform(), encryptor];

// ------------------ Root Reducer ------------------
const rootReducer = combineReducers({
  student: studentAttSlice,
  batch: batchSlice,
  user: userSlice,
  department: departmentSlice,
  exam: examSlice,
});

// ------------------ Persist Config ------------------
const persistConfig = {
  key: "root",
  version: 5,
  storage,
  transforms: transforms,
  migrate: createMigrate(migrations, { debug: false }),
  whitelist: ["user", "department", "exam"], // only persist these
};

// ------------------ Persisted Reducer ------------------
const persistedReducer = persistReducer(persistConfig, rootReducer);
// ------------------ Store ------------------
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck:false
    //  {
    //   ignoredActions: [
    //     "persist/PERSIST",
    //     "persist/REHYDRATE",
    //     "persist/FLUSH",
    //     "persist/PAUSE",
    //     "persist/PURGE",
    //     "persist/REGISTER",
    //   ],
    // },
  }),
  devTools: process.env.NODE_ENV !== "production",
});

// ------------------ Persistor ------------------
export const persistor = persistStore(store);

// ------------------ Types ------------------
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

const saveToSessionStorage = (state: RootState) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem("state", serializedState);
  } catch (e) {
    // console.log(e);
  }
};
 if (process.env.NODE_ENV === "development") {
  store.subscribe(() => saveToSessionStorage(store.getState()));
}
